"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTheme = void 0;

var _colors = require("./colors.theme");

var _controls = require("./controls.theme");

var _breakpoints = require("./breakpoints.theme");

var _typography = require("./typography.theme");

var _spacing = require("./spacing.theme");

var _graphs = require("./graphs.theme");

var _shadows = require("./shadows.theme");

var _fonts = require("./fonts.theme");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BaseTheme = _objectSpread({
  name: 'BaseTheme',
  dark: false,
  colors: _objectSpread({}, _colors.colors, {
    primaryFontDisabledOpacity: 0.3
  })
}, _controls.controls, {
  breakpoints: _objectSpread({}, _breakpoints.breakpoints),
  typography: _objectSpread({}, _typography.typography),
  spacing: _objectSpread({}, _spacing.spacing),
  graphs: _objectSpread({}, _graphs.graphs),
  shadows: _objectSpread({}, _shadows.shadows),
  containerMaxWidth: '1080px'
}, _fonts.fonts);

exports.BaseTheme = BaseTheme;